import { toBaseStudyEntity } from './study-entity.js';
import { checkDefined } from 'faro-common-model';
import { StudyEntityType } from './study-entity-type.js';
export const stageNameMaxLength = 140;
export const stageSizeMaxValue = 10000000;
export const gateNameMaxLength = 140;
export const gateDescriptionNaxLength = 250;
/**
 * @return the built Stage entity
 */
export function toStage(stage) {
    checkDefined(stage.populationId, 'Stage', 'populationId');
    return {
        ...toBaseStudyEntity(stage, StudyEntityType.Stage),
        populationId: stage.populationId,
        name: stage.name,
        size: stage.size,
        gate: toGate(stage.gate),
    };
}
export function toGate(gate) {
    return {
        name: gate === null || gate === void 0 ? void 0 : gate.name,
        description: gate === null || gate === void 0 ? void 0 : gate.description,
    };
}
//# sourceMappingURL=stage.js.map